import { render, staticRenderFns } from "./HeaderDarkGray.vue?vue&type=template&id=21b05fee&scoped=true&"
import script from "./HeaderDarkGray.vue?vue&type=script&lang=js&"
export * from "./HeaderDarkGray.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDarkGray.vue?vue&type=style&index=0&id=21b05fee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b05fee",
  null
  
)

export default component.exports